import { ProductType } from "../enums/product-type";
import { ClickEcommerceTrackingData } from "./click-ecommerce-tracking-data.class";
export class UniversityCardClickEcommerceTrackingData extends ClickEcommerceTrackingData {
    productId;
    listPageType;
    listName;
    listPosition;
    constructor(productId, listPageType, listName, listPosition) {
        super(productId, listPageType, listName, productId, undefined, undefined, listPosition, undefined, undefined, ProductType.UNIVERSITY);
        this.productId = productId;
        this.listPageType = listPageType;
        this.listName = listName;
        this.listPosition = listPosition;
    }
    getTrackingContext() {
        return {
            organisationId: this.getProductId(),
            studyId: undefined,
            scholarshipId: undefined,
            bodyId: undefined,
            premiumnessLevel: this.premium?.toString() ?? '',
            price: undefined,
            position: this.listPosition,
            currency: this.getCurrency()
        };
    }
}
